import React, { useState } from 'react';
import ReactSVG from 'react-svg';
import { disableBodyScroll } from 'body-scroll-lock';
import chevron from 'chevron-small.svg';
import { useInView } from 'react-intersection-observer';
import AmenitiesModal from './AmenitiesModal';
import ErrorBoundary from '../ErrorBoundary';

function PropertyAmenities({ property }) {
  const [showModal, toggleModal] = useState(false);

  const { amenities } = property;

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <section
      ref={ref}
      id="amenities"
      className="main-content-section"
      style={{
        borderTop: '1px solid #e5e5e5',
        paddingTop: '20px',
        marginTop: '20px',
      }}
    >
      {inView && (
        <>
          <h3 className="section-title">Amenities</h3>
          <div className="property-amenities-container">
            {amenities.slice(0, 9).map((amenity, ind) => (
              <p key={ind}>{amenity.table.amenity_name}</p>
            ))}
          </div>
          {/* eslint-disable-next-line */}
          <button
            aria-label="Show Amenities"
            name="Show Amenities"
            className="property-amenities-preview"
            onClick={() => {
              toggleModal(true);
              disableBodyScroll(document.querySelector('.amenities-list'));
            }}
          >
            <span>Show all {amenities.length} Amenities</span>
            <ReactSVG className="chevron-down" src={chevron} />
          </button>
          <AmenitiesModal
            showModal={showModal}
            toggleModal={toggleModal}
            amenities={amenities}
          />
        </>
      )}
    </section>
  );
}

export default function PropertyAmenitiesWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <PropertyAmenities {...props} />
    </ErrorBoundary>
  );
}
